import { http, HttpResponse } from 'msw';
import { API, BASE_URL_V3 } from '../../../src/common/constants';
import type { GetPermittedAssetsApiResponse } from '../../../src/store/facade/facadeApiV3';
import { vehiclesMock } from '../data/vehicles';

const URL = `${BASE_URL_V3}${API.endpoints.vehicles}`;

export const successHandler = http.get(URL, () => {
    const data: GetPermittedAssetsApiResponse = vehiclesMock;
    return HttpResponse.json(data);
});

export const emptyHandler = http.get(URL, () => {
    const data: GetPermittedAssetsApiResponse = { items: [] };
    return HttpResponse.json(data);
});

export const errorHandler = http.get(URL, () => {
    return HttpResponse.error();
});

export const vehiclesResource = {
    success: successHandler,
    error: emptyHandler,
    empty: errorHandler,
};
